
export default {
	name: 'App',
	components: {

	},
	data(){
		return{

		}
	},
	methods:{

	},
	mounted(){



	}
}

